<template>
  <tr v-if="$route.query.style_list === 'table'" :class="blocked ? 'blocked' : ''">
    <td>
      <div class="main">
        <EmployeesPhoto
          :size="30"
          :img="employee.user.photo"
          :textFirst="employee.user.last_name"
          :textSecond="employee.user.first_name"
        />
        {{ employee.user.first_name + ' ' + employee.user.last_name }}
      </div>
    </td>
    <td>{{ employee.user.email }}</td>
    <td>
      {{
        employee.user.work_role
          ? employee.user.work_role.name
          : localStorage.translations.pages.personnel_department.employees_card[
              'dolzhnost-ne-naznachena'
            ]
      }}
    </td>
    <td>
      {{
        employee.group
          ? employee.group.name
          : localStorage.translations.pages.personnel_department.employees_card[
              'ne-sostoit-v-podrazdelenii'
            ]
      }}
    </td>
  </tr>
  <router-link
    v-else
    :to="{
      name: 'PersonalAreaEmployee',
      params: { userId: employee.user.id },
    }"
    class="employee"
    :class="blocked ? 'blocked' : ''"
  >
    <div class="employee__head">
      <div class="employee__head__col employee__head__col--left">
        <BaseTooltip
          :tooltip="localStorage.translations.pages.projects.pages['statistics']"
          max-content
        >
          <router-link
            :to="{
              name: 'employeeStatistic',
              params: { userId: employee.user.id, employeeId: employee.id },
            }"
          >
            <BaseButton class="statistics" round size="40" icon_only minimalize>
              <template v-slot:icon>
                <BaseIcon icon="pages-projects-statistic" />
              </template>
            </BaseButton>
          </router-link>
        </BaseTooltip>
        <v-tooltip v-if="userAgentData" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div class="devices" v-on="on" v-bind="attrs">
              <IconDevices :type="userAgentData.os.name" />
            </div>
          </template>
          <span>{{ userAgentData.ua }}</span>
          <div>
            <div v-if="userAgentData.os.name">
              OS:
              {{
                userAgentData.os.name +
                ' ' +
                (userAgentData.os.version ? userAgentData.os.version : '')
              }}
            </div>
            <div v-if="userAgentData.browser.name && userAgentData.browser.version">
              Browser:
              {{ userAgentData.browser.name + ' ' + userAgentData.browser.version }}
            </div>
            <div v-if="userAgentData.app && userAgentData.app.name && userAgentData.app.version">
              App:
              {{ userAgentData.app.name + ' ' + userAgentData.app.version }}
            </div>
            <div v-if="userAgentData.device.vendor && userAgentData.device.model">
              Device:
              {{ userAgentData.device.vendor + ' ' + userAgentData.device.model }}
            </div>
            <div>
              Date:
              {{ employee.user.last_request ? $formatDate(employee.user.last_request) : '-' }}
            </div>
          </div>
        </v-tooltip>
        <template v-else> -</template>
        <div class="start f10 fw700" :class="{ 'start--active': employee.today_start }">START</div>
      </div>
      <div class="employee__head__photo">
        <EmployeesPhoto
          :size="98"
          :img="employee.user.photo"
          :textFirst="employee.user.last_name"
          :textSecond="employee.user.first_name"
        />
      </div>
      <div class="employee__head__col employee__head__col--right">
        <EmployeeProjectsModal
          v-if="employee.projects_count"
          :projects="employee.projects"
          :projects_count="employee.projects_count"
        />
        <EmployeeWorkTypesModal
          :works="employee.work_types"
          :employeeId="employee.id"
          :onDownloadPageData="onDownloadPageData"
        />
        <div
          class="project"
          v-if="employee.manager_projects_count || employee.responsible_projects_count || employee.sales_manager_projects_count"
        >
          <EmployeeProjectsModal
            v-if="employee.manager_projects_count"
            :projects="employee.manager_projects"
            :projects_count="employee.manager_projects_count"
            type="manager"
          />
          <EmployeeProjectsModal
            v-if="employee.responsible_projects_count"
            :projects="employee.responsible_projects"
            :projects_count="employee.responsible_projects_count"
            type="responsible"
          />
          <EmployeeProjectsModal
            v-if="employee.sales_manager_projects_count"
            :projects="employee.sales_manager_projects"
            :projects_count="employee.sales_manager_projects_count"
            type="sales"
          />
        </div>
        <v-tooltip v-if="employee && employee.group" bottom>
          <template v-slot:activator="{ on, attrs }">
            <div v-on="on" v-bind="attrs">
              <BaseIcon icon="pages-hr-employees_group" width="24" height="24" color="var(--v-primary-base)" />
            </div>
          </template>
          <span>
            {{ employee.group ? employee.group.name : localStorage.translations.pages.personnel_department.employees_card['ne-sostoit-v-podrazdelenii'] }}
          </span>
        </v-tooltip>
      </div>
    </div>
    <div class="employee_body">
      <EmployeeRolesLinkModal :employee="employee" chip />
      <h6 class="f18 fw500">
        {{ employee.user.first_name + ' ' + employee.user.last_name }}
      </h6>
      <p class="f16">
        {{ employee.user.email }}
      </p>
    </div>
  </router-link>
</template>

<script>
import EmployeeRolesLinkModal from 'components/employees/EmployeeRolesLinkModal'
import EmployeeProjectsModal from 'components/employees/EmployeeProjectsModal'
import EmployeeWorkTypesModal from 'components/employees/EmployeeWorkTypesModal'
import EmployeesPhoto from 'components/employees/EmployeesPhoto'
import IconDevices from 'components/icons/IconDevices'

export default {
  name: 'EmployeesListItem',
  props: { employee: [Array, Object], onDownloadPageData: Function },
  components: {
    EmployeesPhoto,
    IconDevices,
    EmployeeRolesLinkModal,
    EmployeeProjectsModal,
    EmployeeWorkTypesModal,
  },
  computed: {
    apiDomain() {
      return this.$store.state.apiDomain
    },
    userAgentData() {
      if (this.employee.user.last_user_agent) {
        if (this.employee.user.last_user_agent.indexOf('ProApp') !== -1) {
          let result = {
            ua: this.employee.user.last_user_agent,
            os: {},
            app: {},
            device: {},
            browser: {},
          }
          let [app, data] = this.employee.user.last_user_agent.split(/(?!\(.*)\s(?![^(]*?\))/g)
          data = data.replace(/[()]/g, '')
          result.app.name = app.split('/')[0]
          result.app.version = app.split('/')[1]
          result.os.name = data.split('; ')[2].split(' ')[0]
          result.os.version = data.split('; ')[2].split(' ')[1]
          return result
        } else return this.userAgentParser(this.employee.user.last_user_agent)
      } else return null
    },
    blocked() {
      return this.employee && this.employee.user ? this.employee.user.blocked === 1 : false
    },
  },
  methods: {
    userAgentParser(ua) {
      var parser = require('ua-parser-js')
      return parser(ua)
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  display: grid;
  grid-template-columns: -webkit-max-content auto;
  grid-template-columns: max-content auto;
  -moz-column-gap: 10px;
  column-gap: 10px;
  align-items: center;
}

.employee {
  background: #ffffff;
  border: 1px solid #bedbeb;
  border-radius: 4px;
  text-align: center;
  padding: 18px;
  display: grid;
  justify-content: center;
  justify-items: center;
  text-decoration: none;
  grid-template-columns: 1fr;
  transition: 0.3s;
  //align-content: space-between;

  &__head {
    width: 100%;
    display: grid;
    grid-template-columns: 40px 1fr 80px;
    grid-template-rows: max-content;
    justify-content: center;
    justify-items: center;
    &__photo {
      margin-right: -40px;
    }
    &__col {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      gap: 14px;
      &--right {
        align-items: flex-end;
        width: 100%;
      }
      .statistics {
        button {
          padding: 0 !important;
          width: 30px !important;

          .base-icon {
            width: inherit;

            svg {
              width: 100%;
              height: auto;
            }
          }
        }
      }

      .devices {
        height: max-content;
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 30px;

        svg {
          width: 30px;
          height: auto;
        }
      }

      .start {
        color: #828282;
        position: relative;
        padding: 8px;
        border: 1px solid #828282;
        border-radius: 9px;

        &::before {
          content: '';
          display: block;
          position: absolute;
          left: 50%;
          top: 25%;
          color: red;
          width: 90%;
          height: 1px;
          background: #c4c4c4;
          transform: rotate(-15deg) translate(-50%, -50%);
        }

        &--active {
          &::before {
            content: none;
          }
          color: #219653;
          border: 1px solid #219653;
        }
      }
      .project {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row-reverse;
        gap: 20px;
      }
    }
  }

  &_body {
    width: 100%;
  }

  &__group {
    color: #828282;

    &--on {
      color: #16558f;
    }
  }

  .status {
    background: #26bc2c;
    border-radius: 4px;
    padding: 4px 8px;
    font-weight: 500;
    font-size: 12px;
    line-height: 148%;
    color: #ffffff;
  }

  h6 {
    line-height: 21px;
    color: #323c47;
    margin: 8px 0px;
  }

  &:hover {
    box-shadow: 0px 0px 16px rgba(67, 142, 184, 0.4);
  }
}
.blocked {
  background-color: #dbdbdb !important;
}
</style>
